import { List, Map } from 'immutable';
import {
  records as jobsRecords,
  types as jobsTypes,
} from '@saucelabs/sl-module-jobs';

import * as types from './types';
import { types as filterTypes } from './../filters';

const initialState = Map({
  manual: List(),
  manualLoading: true,
});

const flatManualReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case jobsTypes.MANUAL_JOBS_GET.FAILURE:
      return state.set('manualLoading', false);
    case jobsTypes.MANUAL_JOBS_GET.SUCCESS: {
      const jobs = payload.jobs.map((job) => new jobsRecords.JobRecord(job));
      return state.withMutations((mutable) => (
        mutable
          .set('manual', List(jobs))
          .set('manualLoading', false)
      ));
    }
    case filterTypes.CLEAR_OWNER:
    case filterTypes.CLEAR_STATUSES:
    case filterTypes.SELECT_OWNER:
    case filterTypes.TOGGLE_STATUS:
      return state.set('manualLoading', true);
    case types.CLEANUP:
      return initialState;
    default:
      return state;
  }
};

export default flatManualReducer;
